<template>
  <div class="product-carousel-container">
    <Carousel
      ref="productCarousel"
      :mouse-drag="true"
      :navigation-enabled="false"
      :pagination-enabled="false"
      :autoplayTimeout="3000"
      :autoplay="true"
      :loop="true"
      :per-page-custom="perPageCustom"
      :speed="3000"
      :scroll-per-page="false">
      <Slide
        v-for="(product, index) in products"
        :key="product.id"
        :data-index="index">
        <div class="product-carousel-card">
          <div class="media">
            <img :src="product.image_url"/>
            <div class="mask">
              <h4>{{ product.name_ch }}{{product.size}}</h4>
              <p>¥{{ product.price_market }}</p>
            </div>
          </div>
        </div>
      </Slide>
    </Carousel>
  </div>
</template>

<script>
  import { Carousel, Slide } from 'vue-carousel';
  export default {
    name: "product-carousel",
    components: {
      Carousel,
      Slide,
    },
    props: {
      products: { type: Array, default: () => []},
    },
    data(){
      return {
        carouselPage: 0,
        postUpdating: false,
        perPageCustom: [[1900, 5], [1315, 4], [1010, 3], [960, 2], [768, 1]],
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/material-kit/_variables.scss";
  .product-carousel-card {
    padding: 2rem;
    height: 20rem;


    .media {
      position: relative;
      transition: all 0.3s;
      box-shadow: $light-shadow;
      height: 16rem;
      width: 16rem;
      border-radius: 50%;

      img {
        height: 16rem;
        width: 16rem;
        object-fit: contain;
        border-radius: 50%;
        overflow: hidden;
      }

      .mask {
        position: absolute;
        border-radius: 50%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        flex-direction: column;
        visibility: hidden;
        align-items: center;
        background: rgba(0,0,0,0.7);
        color: white;
      }

      &:hover {
        cursor: pointer;
        transform: translateY(-5px);
        box-shadow: $heavy-shadow;

        .mask {

          visibility: visible;
        }
      }

    }
  }
</style>